import React from 'react'
import selectPhotoButtonImg from '../../../img/select_photo_button.png';
import { useNavigate } from 'react-router-dom';

interface Props {
    imageUrl: string;}

const SelectPhotoButton: React.FC<Props> = ({ imageUrl }) => {
    const navigate = useNavigate();
    const handleClick = () => {
        const fileInput = document.getElementById("customFileInput") as HTMLInputElement;
        if (fileInput) {
            fileInput.click();
        }
    }
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if(file){
            navigate("../user/photo-confirmation", { state: { photo: file } });
        }
    };

    return (
        <>
            <a  onClick={handleClick}  style={{display: 'flex', justifyContent: 'center'}}>
                <img src={imageUrl} alt='写真を撮る/選ぶ' style={{width: '92%'}}/>
            </a>
            <input
                type="file"
                accept="image/*"
                id="customFileInput"
                onChange={handleFileChange} // ファイル選択時の処理
                style={{ display: "none" }}
            />
        </>
    )
}

export default SelectPhotoButton;
